import { preloadPlayer } from '../common/Player';

export const switchBodyScroll = ({ isBlocked }) => {
	const overflowValue = isBlocked ? 'hidden' : 'visible';
	const html = document.querySelector('html');
	const body = document.querySelector('body');
	html.style.overflow = overflowValue;
	body.style.overflow = overflowValue;
};

export function checkIfWebPSupported() {
	if (window.isWebPSupported !== undefined) return window.isWebPSupported;
	let elem = document.createElement('canvas');
	let isWebPSupported = false;
	if (elem.getContext && elem.getContext('2d')) {
		isWebPSupported = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
	}
	window.isWebPSupported = isWebPSupported;
	return isWebPSupported;
}

export function getTheBestImageFormat({ webp, backupImage }) {
	const isWebP = checkIfWebPSupported();
	if (isWebP) return webp;
	return backupImage;
}

export function preloadVideoPlayer() {
	window.addEventListener('load', () => {
		preloadPlayer();
	});
}
